import CryptoJS from "crypto-js";
const SECRET_KEY = "TUGOFOODORDERAPP";
//export * from "./cart";
export const priceFormat = (price) => {
  if (price == null || isNaN(price)) {
    return "£0.00"; // Default value if price is null, undefined, or not a number
  }
  return price.toLocaleString("en-US", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
  });
};

// export const maskEmail = function (email) {
//   return email.replace(/(.{2})(.*)(?=@)/, function (gp1, gp2, gp3) {
//     for (let i = 0; i < gp3.length; i++) {
//       gp2 += "*";
//     }
//     return gp2;
//   });
// };

export const maskEmail = (email) => {
  const [name, domain] = email.split("@");

  if (name.length <= 2) {
    // for very short usernames (1–2 chars)
    return name[0] + "*@" + domain;
  } else if (name.length <= 4) {
    // for 3–4 chars: keep first, mask the rest
    return name[0] + "*".repeat(name.length - 1) + "@" + domain;
  } else {
    // for long ones: Gmail-style (first 2, last 2, 3 stars in middle)
    const visibleStart = name.slice(0, 2);
    const visibleEnd = name.slice(-2);
    return `${visibleStart}****${visibleEnd}@${domain}`;
  }
};

const encryptData = (data) => {
  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY
  ).toString();
  return encrypted;
};

const decryptData = (encrypted) => {
  if (encrypted !== undefined && encrypted !== null && encrypted !== "[]") {
    const decrypted = CryptoJS.AES.decrypt(encrypted, SECRET_KEY).toString(
      CryptoJS.enc.Utf8
    );
    return JSON.parse(decrypted);
  } else {
    return encrypted;
  }
};

export const setStorage = (key, value) => {
  // localStorage.setItem(key, value);
  localStorage.setItem(key, encryptData(value));
};

export const getStorage = (key) => {
  //return localStorage.getItem(key)
  return decryptData(localStorage.getItem(key));
};

export const str_replace = (product_name) => {
  if (product_name !== "") {
    product_name = product_name.replaceAll("amp;", "&");
    product_name = product_name.replaceAll("apos;'", "'' ");
    product_name = product_name.replaceAll("quot;'", "'' ");

    return product_name;
  } else {
    return product_name;
  }
};

export const getOrderNotes = (OrderNote) => {
  var note_test = OrderNote.replaceAll(" PIXHALLCSL", "");
  note_test = note_test.replaceAll("amp;", "&");
  note_test = note_test.replaceAll("apos;", "'' ");
  note_test = note_test.replaceAll("apos;'", "'' ");
  note_test = note_test.replaceAll("quot;'", "'' ");
  note_test = note_test.replaceAll("quot;", "'' ");
  note_test = note_test.replaceAll("'' '", "'' ");
  return note_test;
};

export const formatDate = (dateString) => {
  const dateObject = new Date(dateString);
  const year = dateObject.getFullYear();
  const month = String(dateObject.getMonth() + 1).padStart(2, "0");
  const day = String(dateObject.getDate()).padStart(2, "0");
  return `${day}/${month}/${year}`;
};

export const enablePopup = (item) => {
  if (
    (item.productUSP !== null && item.productUSP !== "") ||
    (item.productDiet !== null && item.productDiet !== "") ||
    (item.productIngredient !== null && item.productIngredient !== "") ||
    (item.productSpec !== null && item.productSpec !== "")
  ) {
    return true;
  } else {
    return false;
  }
};

export const highlightAllergens = (allergens, str) => {
  allergens.forEach((item) => {
    var strRegExp = new RegExp("\\b" + item.allergenTitle + "\\b", "ig");
    str = str.replace(strRegExp, "<strong>" + item.allergenTitle + "</strong>");
  });

  return <div dangerouslySetInnerHTML={{ __html: str }} />;
};

export const hightLightIngredients = (ingredients, str) => {
  ingredients.forEach((item) => {
    var strRegExp = new RegExp("\\b" + item.ingredientTitle + "\\b", "ig");
    str = str.replace(
      strRegExp,
      "<strong>" + item.ingredientTitle + "</strong>"
    );
  });

  return <div dangerouslySetInnerHTML={{ __html: str }} />;
};

export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string
    .split(/(\s|-)/) // Split by space or hyphen, keeping the delimiter
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
    .join(""); // Join back the words including the delimiters
};

export const showOfferPrice = (originalPrice, offerPercentage) => {

  if (offerPercentage > 0) {
    const discount = (originalPrice * offerPercentage) / 100;
    const offerPrice = originalPrice - discount;
    return (<>
      <span className="amt-ofr-all">{priceFormat(originalPrice * 1)}</span>
      <span className="amt-ofr-get">{priceFormat(offerPrice * 1)}</span>
    </>);
  }
  else {
    return (<span className="amt-ofr-no-offer">{priceFormat(originalPrice * 1)}</span>);
  }
};

export const getOfferPrice = (originalPrice, offerPercentage) => {
  if (offerPercentage > 0) {
    const discount = (originalPrice * offerPercentage) / 100;
    const offerPrice = originalPrice - discount;
    return offerPrice;
  } else {
    return originalPrice;
  }
};

export const TotalproductSoldbyID =(data = [],ProductNumber)=>{
  if (!Array.isArray(data)) return 0;
  const totalQty = data.find((prd) => prd?._id === ProductNumber);
  return totalQty ? totalQty.totalQuantitySold || 0 : 0;
}

 export const dynamicSort = (property) => {
    var sortOrder = 1;

    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }

    return function (a, b) {
      if (sortOrder == -1 && b[property] !== null) {
        return b[property].localeCompare(a[property]);
      } else if (a[property] !== null) {
        return a[property].localeCompare(b[property]);
      }
    };
  };



export const sortAndGroupProductsBySectorSales = ({
  productList = [],
  sectorwiseData = [],
  userSubDepot = null,
  excludeProductNumber = "77775",
  kitchenAccount=null
}) => {
   // Build lookup: productNumber => totalQuantitySold
  const productListNew =  productList.map((item)=>{
    return {...item, Qtysold: TotalproductSoldbyID(sectorwiseData || [],item.productNumber)}
   }).sort((a,b)=>{
  const qtyDiff = parseInt(a.Qtysold) - parseInt(b.Qtysold);
  if (qtyDiff !== 0) return qtyDiff;
  return a.PDP_IDNo - b.PDP_IDNo;
});
   
  // Filter by subDepot (if available)
  let filteredProducts = productListNew.filter((product) => {
     if (
    product.productNumber === excludeProductNumber ||
    (product.PDP_Price1 === "0" && kitchenAccount !== "Yes")
  ) {
    return false;
  }
    if (!product.activeDepots || !userSubDepot) return true;
    return product.activeDepots.split("/").includes(userSubDepot);
  });

  // Sort by ProductGroup
   //let sortPriceAsec = filteredProducts.sort((a, b) => a.PDP_IDNo - b.PDP_IDNo);
  filteredProducts.sort(dynamicSort("ProductGroup")); 
  // ProductGroup list
  let productGroupList = filteredProducts
    .map((item) => item.ProductGroup)
    .filter((val) => val !== "" && val !== null);
  productGroupList = [...new Set(productGroupList)];

  // Group and sort within group based on sectorwise products sold
  let groupProductsList = [];
  productGroupList.forEach((groupName) => {
    let groupProducts = filteredProducts.filter(
      (p) => p.ProductGroup === groupName
    );

    // groupProducts.sort((a, b) => {
    //   return a.productNumber.localeCompare(b.productNumber)
    // });

    if (groupProducts.length > 0) {
      groupProductsList.push({ [groupName]: groupProducts });
    }
  });
 
  return {
    sortedProducts: filteredProducts,
    groupFilterList: productGroupList,
    groupProductsList,
    suitableForList: [...new Set(filteredProducts.map((p) => p.SuitableFor).filter(Boolean))]
  };
 
};

export const isMenuVisible = (promos, menuKey, userPriceBand) => {
  if (!Array.isArray(promos) || !userPriceBand) return false;

  return promos.some(promo => {
    if (promo.Status !== 'active') return false;
    if (!promo[menuKey]) return false; // isMonthly / isDownloads

    let excluded = promo.PriceBandTobeExcluded || [];

    if (typeof excluded === 'string') {
      excluded = excluded.split(',').map(b => b.trim());
    }

    // hide menu if user priceband is excluded
    return !excluded.includes(userPriceBand);
  });
};

export const filterPromosByPriceBand = (promos, userPriceBand) => {
  if (!Array.isArray(promos)) return [];

  return promos.filter(promo => {
    let restricted = promo.PriceBandTobeExcluded ?? [];

    if (typeof restricted === 'string') {
      restricted = restricted.split(',').map(b => b.trim());
    }

    if (userPriceBand && restricted.includes(userPriceBand)) {
      return false;
    }

    return true;
  });
};

export const isValidHTMLContent = (html) => {
  if (!html) return false;

  const cleaned = html
    .replace(/<[^>]*>/g, "")   // remove HTML tags
    .replace(/&nbsp;/g, " ")   // replace &nbsp;
    .trim();                  // trim spaces

  return cleaned.length > 0;
};